// ====================================================================
// ziven-core forum DiscussionThumbnails - v0.5.11
// ====================================================================
//
// 帖子列表页缩略图小黑盒样式 (辉哥 9/4 15:13 反馈, 派 Coder 干).
// 跟 v0.4.x 时代 modifyDiscussionItem.js jQuery 拼字符串模式不同, v0.5.11
// 走 mithril 组件, 但保留 1 个静态 renderHtml() 给 jQuery fallback 用 (mobile
// 模式整卡片重组是 jQuery 注入另一张卡片, 跟 mithril 渲染管线分离).
//
// Props: discussion (Flarum Discussion model)
// 读 discussion.imageCount() + discussion.imageList() (v0.5.11 新加的
// ApiResource attributes, 见 src/Api/DiscussionAttributes.php)
//
// 渲染规则 (辉哥拍板):
//   - 0 张: return null (不显示缩略图区)
//   - 1 张: 1 张大图 (aspect-ratio: 16/9, 全宽)
//   - 2-3 张: 横排并排 (aspect-ratio: 4/3, gap: 4-8px)
//   - 4+ 张: 前 3 张 + 右上角 N+张 徽章 (绝对定位, N = imageCount - 3)
//
// 样式: less/forum.less 加 .DiscussionThumbnails (深色卡片背景 + 圆角 8px +
//       object-fit: cover + max-width: 100%)
// ====================================================================
import app from 'flarum/forum/app';

// t() 扁平化 — ziven-dress-up 沉淀的 i18n 习惯 + Symfony ICU MessageFormat 支持
// Symfony translator 返数组 (字面值 + placeholder 拆开), 必须 join('') 才能渲染
function t(key, params) {
  const result = params ? app.translator.trans(key, params) : app.translator.trans(key);
  return Array.isArray(result) ? result.join('') : result;
}
export default class DiscussionThumbnails {
  /**
   * 静态方法: 返 HTML 字符串 (供 jQuery append 用, mobile 模式用)
   * @param {Array} imageList - URL 数组 (Flarum attribute, 已经是 array, 限 max 后)
   * @param {number} imageCount - 总图数 (不限 max, 用于 4+ 徽章 "N+张")
   * @returns {string} HTML 字符串
   */
  static renderHtml(imageList, imageCount) {
    // 读 max setting, max=0 (禁用) 不渲染缩略图
    // 改 max=0 不会清空已存在帖子的 imageList, 所以前端必须自己判断
    const maxCount = (() => {
      try {
        const v = app.forum.attribute('zivenCoreThumbnailsMaxCount');
        return typeof v === 'number' ? v : 3;
      } catch (e) {
        return 3;
      }
    })();
    if (maxCount <= 0) return '';
    if (!imageCount || !imageList || imageList.length === 0) return '';
    if (!Array.isArray(imageList)) return '';

    // 1 张: 大图 (全宽 16/9)
    if (imageCount === 1) {
      return "<div class=\"DiscussionThumbnails DiscussionThumbnails--single\">\n        <div class=\"DiscussionThumbnails-image\" style=\"background-image: url('".concat(imageList[0], "')\"></div>\n      </div>");
    }

    // 2-3 张: 横排并排 (imageCount 限 3 张以内就并排)
    if (imageCount <= 3) {
      const items = imageList.map(url => "<div class=\"DiscussionThumbnails-image\" style=\"background-image: url('".concat(url, "')\"></div>")).join('');
      return "<div class=\"DiscussionThumbnails DiscussionThumbnails--multi\">".concat(items, "</div>");
    }

    // 4+ 张: 显示 imageList 全部 (受 max 限) + 徽章
    // overflow = imageCount - imageList.length (例如 max=3, imageCount=5 → overflow=2, 徽章 "2+张")
    // 例如 max=1, imageCount=5 → overflow=4, 徽章 "4+张"
    const items = imageList.map(url => "<div class=\"DiscussionThumbnails-image\" style=\"background-image: url('".concat(url, "')\"></div>")).join('');
    const overflow = imageCount - imageList.length;
    // Symfony translator 传 params 让 {n} 正确替换, t() 处理数组 join
    const badgeText = t('ziven-community-core.forum.thumbnail_overflow', {
      n: overflow
    });
    return "<div class=\"DiscussionThumbnails DiscussionThumbnails--multi DiscussionThumbnails--overflow\">\n      ".concat(items, "\n      <div class=\"DiscussionThumbnails-badge\">").concat(badgeText, "</div>\n    </div>");
  }

  /**
   * mithril view() — 给 extend(DiscussionListItem.prototype, 'mainView') 用
   * 渲染 raw HTML (m.trust 信任), 跟静态方法共用同一份 HTML 生成逻辑
   */
  view(vnode) {
    const discussion = vnode.attrs.discussion;
    if (!discussion) return null;

    // 读 max setting, max=0 (禁用) 不渲染
    const maxCount = (() => {
      try {
        const v = app.forum.attribute('zivenCoreThumbnailsMaxCount');
        return typeof v === 'number' ? v : 3;
      } catch (e) {
        return 3;
      }
    })();
    if (maxCount <= 0) return null;

    // Flarum 2.0 序列化器 camelCase 自动 from snake_case
    const imageCount = discussion.imageCount ? discussion.imageCount() : discussion.attribute('imageCount') || 0;
    const imageList = discussion.imageList ? discussion.imageList() : discussion.attribute('imageList') || [];
    if (!imageCount || !imageList || imageList.length === 0) return null;
    const html = DiscussionThumbnails.renderHtml(imageList, imageCount);
    if (!html) return null;
    return m('.DiscussionThumbnailsWrapper', m.trust(html));
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/DiscussionThumbnails', DiscussionThumbnails);